export const TOGGLE_STAFF_UP = "TOGGLE_STAFF_UP"


export function toggleStaffUp(){
  return {
    type: TOGGLE_STAFF_UP
  }
}



// WEBPACK FOOTER //
// ./src/seats/seats_actions.js